import { MantineSpacing, StyleProp, Text } from '@mantine/core';

import classes from './index.module.css';

interface ISectionLabel {
  label: string;
  pb?: StyleProp<MantineSpacing>;
  variant?: string;
  weight?: number;
}

const SectionLabel = ({
  label,
  pb,
  variant = 'dark',
  weight,
}: ISectionLabel) => {
  return (
    <Text className={`${classes.label} ${classes[variant]}`} fw={weight} pb={pb}>{label}</Text>
  );
};

export default SectionLabel;
